import React from 'react';
import classNames from 'classnames';

import css from './Topbar.module.css';

/**
 * Location icon (pin icon)
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} location icon
 */
const LocationIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootLocationIcon, className);

  return (
    <svg
      className={classes}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 7.5c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 1 1 12 0z" />
        <circle cx="9" cy="7.5" r="2.25" />
      </g>
    </svg>
  );
};

export default LocationIcon;